<template>
    <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 0.74475C0.00137253 0.547784 0.0801752 0.359263 0.219385 0.219913C0.358594 0.0805634 0.547035 0.00157099 0.744 0H14.256C14.667 0 15 0.33375 15 0.74475V12.7552C14.9986 12.9522 14.9198 13.1407 14.7806 13.2801C14.6414 13.4194 14.453 13.4984 14.256 13.5H0.744C0.54661 13.4998 0.357373 13.4212 0.217867 13.2816C0.0783615 13.142 -1.00091e-07 12.9526 0 12.7552V0.74475ZM1.5 1.5V12H13.5V1.5H1.5ZM6.4665 4.06125L10.1258 6.50025C10.1669 6.52764 10.2006 6.56476 10.224 6.60834C10.2473 6.65191 10.2595 6.70057 10.2595 6.75C10.2595 6.79943 10.2473 6.84809 10.224 6.89166C10.2006 6.93524 10.1669 6.97236 10.1258 6.99975L6.46575 9.43875C6.42062 9.46866 6.36824 9.48581 6.31415 9.48836C6.26007 9.49092 6.2063 9.47879 6.15856 9.45326C6.11081 9.42773 6.07086 9.38976 6.04294 9.34337C6.01503 9.29698 6.00019 9.24389 6 9.18975V4.31025C6.0001 4.25599 6.01492 4.20277 6.04287 4.15626C6.07082 4.10975 6.11086 4.0717 6.15873 4.04615C6.2066 4.0206 6.26051 4.00851 6.3147 4.01117C6.3689 4.01383 6.42136 4.03113 6.4665 4.06125Z"
            fill="currentColor"
        />
    </svg>
</template>
